<template>
  <svg viewBox="0 0 24 24">
    <path fill="currentColor" d="M8 5.14v14l11-7l-11-7Z"></path>
  </svg>
</template>

<script>
export default {
  name: "MdiPlay",
};
</script>
